// Assets
import imgAntonio from "../assets/img/team/antonio.jpg";
import imgBruno from "../assets/img/team/bruno.jpg"
import imgCadu from "../assets/img/team/carlos.jpeg";
import imgDanilo from "../assets/img/team/danilo.jpg";
import imgEduardo from "../assets/img/team/eduardo.jpg";
import imgEnrico from "../assets/img/team/enrico.jpg";
import imgErik from "../assets/img/team/erik.jpg";
import imgGabriel from "../assets/img/team/gabriel_lencina.jpg";
import imgHelder from "../assets/img/team/helder.jpg";
import imgJacks from "../assets/img/team/jacks.jpeg";
import imgJimy from "../assets/img/team/jimy.jpg";
import imgJob from "../assets/img/team/job.jpg";
import imgKarla from "../assets/img/team/karla.jpg";
import imgLeomar from "../assets/img/team/leomar.jpeg";
import imgLucas from "../assets/img/team/lucas.jpg";
import imgMoises from "../assets/img/team/moises.jpg";
import imgMurillo from "../assets/img/team/murillo.jpg";
import imgNathalia from "../assets/img/team/nathalia.jpg";
import imgPedro from "../assets/img/team/pedro.jpg";
import imgThiagoReis from "../assets/img/team/thiago_reis.jpg";
import imgYan from "../assets/img/team/yan.jpg";

const teamList = [
    {
        name: "Antônio Chacarosque",
        img: imgAntonio,
    },
    {
        name: "Bruno Bortolato",
        img: imgBruno,
    },
    {
        name: "Carlos Gomes",
        img: imgCadu,
    },
    {
        name: "Danilo Ribacinko",
        img: imgDanilo,
    },
    {
        name: "Eduardo Cabral",
        img: imgEduardo,
    },
    {
        name: "Enrico Caliolo",
        img: imgEnrico,
    },
    {
        name: "Erik Gabriel",
        img: imgErik,
    },
    {
        name: "Gabriel Lencina",
        img: imgGabriel,
    },
    {
        name: "Helder Henrique",
        img: imgHelder,
    },
    {
        name: "Jimy Li Yan",
        img: imgJimy,
    },
    {
        name: "Job Ferreira",
        img: imgJob,
    },
    {
        name: "Karla Francisco",
        img: imgKarla,
    },
    {
        name: "Leomar Marschalk",
        img: imgLeomar,
    },
    {
        name: "Lucas Garcia",
        img: imgLucas,
    },
    {
        name: "Matheus Jacks",
        img: imgJacks,
    },
    {
        name: "Moises da Costa",
        img: imgMoises,
    },
    {
        name: "Murillo Pagani",
        img: imgMurillo,
    },
    {
        name: "Nathália Ribas",
        img: imgNathalia,
    },
    {
        name: "Pedro Craveiro",
        img: imgPedro,
    },
    {
        name: "Thiago Reis",
        img: imgThiagoReis,
    },
    {
        name: "Yan Wiverson",
        img: imgYan,
    },
];

export default teamList;
